<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iB8GBb/tc-custom/9781631951800.jpg?1724548221018" alt="This image is the cover for the book Great Opportunity"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Great Opportunity
      </h1>
      <p class="bookDescription body article font2">
        <i>The Great Opportunity</i> takes Christians beyond knowing that their faith should affect their work by showing them why and how to make disciples among those who share their vocation.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dave Buehring
      </h2>
      
      <p class="authorDescription body article"><B>Dave Buehring</B> is a devoted disciple of Jesus, who is engaged in equipping the Church, guiding societal leaders and reproducing disciple makers. Over four-plus decades, he has had the opportunity to lead on local, national, and international fronts. He has had the privilege of speaking at hundreds of conferences and retreats, leadership summits, and training schools. Dave is the Founder and President of the Lionshare Leadership Group, a nonprofit organization aimed at igniting and equipping churches and societal leaders to fulfill Jesus’ Great Co-Mission of making disciple makers. He’s the author of several books, including A Discipleship Journey, a scripturally sound, proven and practical resource used in numerous nations throughout the world. He can also be regularly heard on Lionshare’s podcast Wisdom Unlocked: The Ways of God. Dave annually hosts, A Leadership Journey, his six-month leadership discipling opportunity for church and societal leaders of all kinds. He and his wife, Cheryl, reside in the beautiful hills of Franklin, Tennessee where they enjoy spending time with their family and friends.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e9a4f988